<template>
  <div
    class="ride-list__card__body"
    :class="{ 'ride-list__card__body--bg': hasBackground }"
  >
    <div v-if="status === 'WAITING_DRIVERS_ANSWERS'">
      <p class="list__card__title">{{ $t(`${namespace}.waiting`) }}</p>
      <p class="list__card__text">
        {{ $t(`${namespace}.waitingDrivers`).replace('[EMPLOYEE_NAME]', employeeName) }}
      </p>
    </div>

    <div v-else-if="status === 'COULDNT_FIND_AVAILABLE_DRIVERS'">
      <p class="list__card__text list__card__text--mt">
        {{ $t(`${namespace}.unavailableDrivers`).replace('[EMPLOYEE_NAME]', employeeName) }}
      </p>
    </div>

    <div v-else-if="status === 'DRIVERS_REJECTED'">
      <p class="list__card__text list__card__text--mt">
        {{ $t(`${namespace}.driversRejected`).replace('[EMPLOYEE_NAME]', employeeName) }}
      </p>
    </div>

    <div v-else>
      <div class="item__line">
        <div class="item__label">{{ $t(`${namespace}.employee`) }}</div>
        <div class="item__value text--ellipsis" :title="employeeName">
          {{ employeeName || '-' }}
        </div>
      </div>

      <div class="item__line">
        <div class="item__label">{{ $t(`${namespace}.driver`) }}</div>
        <div class="item__value text--ellipsis" :title="driver.fullName">
          {{ driver.fullName || '-' }}
        </div>
      </div>

      <v-layout>
        <v-flex xs6>
          <div class="item__label">{{ $t(`${namespace}.carModel`) }}</div>
          <div class="item__value text--ellipsis" :title="driver.carModel">
            {{ driver.carModel || '-' }}
          </div>
        </v-flex>

        <v-flex xs3>
          <div class="item__label">{{ $t(`${namespace}.carPlate`) }}</div>
          <div class="item__value text--bold text--ellipsis" :title="driver.carPlate">
            {{ driver.carPlate || '-' }}
          </div>
        </v-flex>

        <v-flex xs3>
          <div class="item__label text-capitalize">{{ $t(`${namespace}.carColor`) }}</div>
          <div class="item__value text--ellipsis" :title="driver.carColor">
            {{ driver.carColor || '-' }}
          </div>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Body',
  props: {
    ride: {
      type: Object,
      required: true
    }
  },
  computed: {
    status () {
      return this.ride && this.ride.status ? this.ride.status : null
    },

    hasBackground () {
      return this.status === 'WAITING_DRIVERS_ANSWERS' ||
        this.status === 'COULDNT_FIND_AVAILABLE_DRIVERS' ||
        this.status === 'DRIVERS_REJECTED'
    },

    employeeName () {
      return this.ride && this.ride.employeeName ? this.ride.employeeName : '-'
    },

    driver () {
      return this.ride && this.ride.running && this.ride.running.driver && this.ride.running.driver
        ? this.ride.running.driver
        : {}
    }
  },
  data () {
    return {
      namespace: 'Views.NewWebCallPage.rideList.card'
    }
  }
}
</script>

<style lang="scss" scoped>
.ride-list__card__body {
  height: 150px;
  padding: 20px;

  &.ride-list__card__body--bg {
    background: url('./img/cars.png') right bottom no-repeat;
    background-size: 120px;
  }
}

.list__card__title {
  color: $gray-7;
  font-size: 18px;
  font-weight: 600;
  line-height: 1;
  margin: 0 0 14px;
}

.list__card__text {
  font-size: 12px;
  margin: 20px 0 0;

  &.list__card__text--mt {
    margin-top: 30px;
  }
}

.item__line {
  margin-bottom: 8px;
}

.item__label {
  color: $gray-6;
  font-size: 10px;
}

.item__value {
  color: $gray-7;
  font-size: 12px;
}
</style>
